<template>
  <div class="drawer-panel-inner">
    <div class="drawer-panel-inner__head">
      <button
        v-if="showBack"
        class="drawer-panel-inner__back"
        @click="back"
      >
        <f-sprite-icon :icon-link="$options.icons.IconBack.id" />
      </button>

      <div class="drawer-panel-inner__title">
        {{ title }}
      </div>
      <button
        class="drawer-panel-inner__close"
        @click="close"
      >
        <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
      </button>
    </div>

    <div class="drawer-panel-inner__content">
      <slot />
    </div>
  </div>
</template>

<script>
import IconClose from '@icons/close.svg';
import IconBack from '@icons/back.svg';

export default {
  icons:{
    IconClose,
    IconBack,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    showBack: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
    back() {
      this.$emit('back');
    }
  }
}
</script>

<style lang="scss">
.drawer-panel-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__head {
    height: 48px;
    display: flex;
    padding: 12px 16px;
    align-items: center;
  }

  &__title {
    flex: 1;
    padding: 0 8px;
    overflow: hidden;
    font-size: 14px;
    white-space: nowrap;
    text-align: center;
    text-overflow: ellipsis;
  }

  &__back {
    width: 24px;
    height: 24px;
    color: $gray_lu;
    text-align: center;
    padding: 0;
    position: relative;
    background: none;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      left: -8px;
      right: -8px;
      top: -8px;
      bottom: -8px;
    }
  }

  &__close {
    width: 24px;
    height: 24px;
    color: $gray_lu;
    text-align: center;
    padding: 0;
    position: relative;
    background: none;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      left: -8px;
      right: -8px;
      top: -8px;
      bottom: -8px;
    }
  }

  &__content {
    flex: 1;
  }
}
</style>